import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/ui/components/arandu/button';
import { useSession } from '@/ui/hooks/use-session';

export const Tagline = () => {
  const { session } = useSession();
  const nav = useNavigate();
  const { t } = useTranslation();

  return (
    <section className='w-full px-mini py-xl md:py-xxl relative'>
      <video
        className='absolute top-0 left-0 w-full h-full object-cover'
        src='https://joebfozvrfyvazbnvoxy.supabase.co/storage/v1/object/public/events/public/organizer-lp-background.webm'
        playsInline
        autoPlay
        muted
        loop
      />
      <div className='absolute inset-0 bg-base-primary-900/semiOpaque' />
      <div className='size-full max-w-[55.5rem] mx-auto flex flex-col items-center gap-xl text-center relative z-10'>
        <h1 className='ts-heading-xl md:ts-heading-display text-ctx-content-titleAlternative '>
          <Trans components={{ span: <span className='text-base-primary-200' /> }} i18nKey='home.tagline.title' />
        </h1>

        <p className='ts-subtitle-lg text-ctx-content-titleAlternative'>{t('home.tagline.description')}</p>

        <div className='flex flex-col items-center md:flex-row gap-sm w-full md:w-auto'>
          <Button
            fullWidth
            hierarchy='secondary'
            className='md:!w-max !text-ctx-layout-spotlight border-2 border-ctx-layout-spotlight hover:border-opacity-transparent !duration-500 ease-in-out'
            onClick={() => {
              window.location.href = import.meta.env.VITE_PUBLIC_URL;
            }}
            size='lg'
          >
            {t('explore-events')}
          </Button>
          <Button
            fullWidth
            hierarchy='primary'
            className='md:!w-max !bg-ctx-layout-spotlight !text-base-primary-800 hover:!bg-base-primary-300 hover:opacity-deep !duration-500 ease-in-out'
            onClick={() => nav(`${session ? '/events' : '/auth/login'}`)}
            size='lg'
          >
            {t('register-my-event')}
          </Button>
        </div>
      </div>
    </section>
  );
};
